import {
  deltaColumnId,
  deltaImpactColumnId,
  type CompareTranslationKey
} from "@/entities/dataTables/compareTo/columnIds";
import type { ServiceCompareMetricKey } from "@/entities/dataTables/compareTo/types";
import type { ServiceData } from "@/entities/services/types";

// Its strings name services, so it cannot share the other grains' namespaces.
export const SERVICE_COMPARE_TRANSLATION_KEY: CompareTranslationKey =
  "services.compareTo";

// This table has no ARR/CARR value column for the Δ to sit beside, so the
// columns are keyed on the response's metric names rather than a column id.
export interface ServiceCompareSlot {
  metricKey: ServiceCompareMetricKey;
  termsMetricKey: ServiceCompareMetricKey;
  /** Translation key for the metric's own label, e.g. `services.arr`. */
  labelKey: string;
}

export const SERVICE_COMPARE_SLOTS: readonly ServiceCompareSlot[] = [
  { metricKey: "arr", termsMetricKey: "arrLocal", labelKey: "services.arr" },
  { metricKey: "carr", termsMetricKey: "carrLocal", labelKey: "services.carr" }
];

// A terms Δ starts hidden wherever this table's other terms columns do.
export const SERVICE_COMPARE_TERMS_COLUMN_IDS: readonly string[] =
  SERVICE_COMPARE_SLOTS.map((slot) => deltaColumnId(slot.termsMetricKey));

// Enumerated, not suffix-matched: a custom field named "Price Delta" becomes
// `priceDelta`, and the export drops exact id matches.
export const SERVICE_COMPARE_COLUMN_IDS: readonly string[] =
  SERVICE_COMPARE_SLOTS.flatMap((slot) => [
    deltaColumnId(slot.metricKey),
    deltaImpactColumnId(slot.metricKey),
    deltaColumnId(slot.termsMetricKey)
  ]);

/**
 * When the service began — the evidence the New label rests on, since the
 * endpoint's `existed: false` cannot tell a new service from an unrecorded one.
 *
 * The start date alone, never `created_at`: a record timestamp is a data-entry
 * artefact, and mixing it in mislabels services entered early, entered late, or
 * carrying no start date. The contract grain does take the earliest of two
 * dates, correctly — both of its dates are commercial events.
 */
export const readServiceRowStart = (row: ServiceData): string | null =>
  row.serviceStartDate;
